import React, { useState } from 'react';
import { Card, Descriptions, Tag, Empty } from 'antd';

const FeedbackEvalMobile = ({ feedbackReportData }) => {
    const [expandedRows, setExpandedRows] = useState([]);

    const toggleRow = (key) => {
        setExpandedRows(prev =>
            prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
        );
    };

    const isExpanded = (key) => expandedRows.includes(key);

    const renderTextWithToggle = (text, key, limit = 150) => {
        if (!text || text.length <= limit) return text;
        const expanded = isExpanded(key);
        return (
            <>
                <div style={{ wordBreak: 'break-word' }}>
                    {expanded ? text : `${text.slice(0, limit)}...`}
                </div>
                <div
                    onClick={() => toggleRow(key)}
                    style={{ padding: 0, cursor: 'pointer', color: '#1890ff' }}
                >
                    {expanded ? 'Read Less' : 'Read More'}
                </div>
            </>
        );
    };

    const renderListWithToggle = (points, key, limit = 2) => {
        if (!Array.isArray(points) || points.length === 0) return <li>None</li>;

        const expanded = isExpanded(key);
        const visiblePoints = expanded ? points : points.slice(0, limit);

        return (
            <>
                <ul style={{ paddingLeft: 16, margin: 0 }}>
                    {visiblePoints.map((point, index) => (
                        <li key={index}>{point}</li>
                    ))}
                </ul>
                {points.length > limit && (
                    <div
                        onClick={() => toggleRow(key)}
                        style={{ padding: 0, cursor: 'pointer', color: '#1890ff' }}
                    >
                        {expanded ? 'Read Less' : 'Read More'}
                    </div>
                )}
            </>
        );
    };

    const data = feedbackReportData?.feedback_report?.map((issue, index) => ({
        key: index,
        ...issue,
    })) || [];

    return (
        <div
            style={{
                maxHeight: "400px",
                overflowY: "auto",
                padding: "10px",
            }}
        >
            {data.length > 0 ? data.map((issue, index) => (
                <Card
                    key={issue.key}
                    style={{
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                        marginBottom: "10px",
                    }}
                    bodyStyle={{ padding: "0px" }}
                >
                    <Descriptions size="small" column={2} bordered>
                        <Descriptions.Item label="Criteria" span={2}>
                            <Tag color="volcano">{issue.criteria}</Tag>
                        </Descriptions.Item>
                        <Descriptions.Item label="AI Score" span={2}>
                            <Tag color="volcano">{issue.ai_evaluation_score}</Tag>
                        </Descriptions.Item>
                        <Descriptions.Item label="Tutor Score" span={2}>
                            <Tag color="red">{issue.tutor_expected_score}</Tag>
                        </Descriptions.Item>
                        <Descriptions.Item label="Similarity" span={2}>
                            <Tag color="blue">{issue.similarity_in_approach}</Tag>
                        </Descriptions.Item>
                        <Descriptions.Item label="AI Feedback" span={2}>
                            {renderTextWithToggle(issue.ai_feedback, `ai-${issue.key}`)}
                        </Descriptions.Item>
                        <Descriptions.Item label="Tutor Feedback" span={2}>
                            {renderTextWithToggle(issue.tutor_feedback, `tutor-${issue.key}`)}
                        </Descriptions.Item>
                        <Descriptions.Item label="Unfollowed Tutor Points" span={2}>
                            {renderListWithToggle(issue.unfollowed_tutor_points, `points-${issue.key}`)}
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            )) : (
                <Empty description="No Feedback Found" />
            )}
            {data?.length > 0 && (
                <p>
                    <strong>Remarks:</strong> {feedbackReportData?.feedback_remarks}
                </p>
            )}
        </div>
    );
};

export default FeedbackEvalMobile;
